export const environment = {
  production: false,
  SMART_API_URL: 'https://www.scientialabspruebas.xyz/smartfondos/api/',
  FONDOS: [
    { codigo: 'C01', descripcion: 'COTIZADO PRIME' },
    { codigo: 'ONE', descripcion: 'ADMINISTRADO ONE' },
  ]
};
